<template>
  <div class="w-auto">
    <div class="statistics-time">
      <p class="statistics-title">
        Общее среднее время ответа специалистов
      </p>

      <chart-statistics-process-time class="w-100" />

      <p class="statistics-info statistics-info-title">
        Итоговые показатели:
      </p>

      <p class="statistics-info">
        Общее среднее время ответа дежурных врачей, мин:

        <span class="crm-info-value">
          {{ totalDutyAverageTakeOnTime }}
        </span>
      </p>

      <p class="statistics-info">
        Общее среднее время ответа дежурного терапевта, мин:

        <span class="crm-info-value">
          {{ totalTherapistAverageTakeOnTime }}
        </span>
      </p>

      <p class="statistics-info">
        Общее среднее время ответа дежурного педиатра, мин:

        <span class="crm-info-value">
          {{ totalPediatricianAverageTakeOnTime }}
        </span>
      </p>

      <p class="statistics-info">
        Общее среднее время ответа узких специалистов, мин:

        <span class="crm-info-value">
          {{ totalSpecializedAverageTakeOnTime }}
        </span>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/types';

import ChartStatisticsProcessTime from './ChartStatisticsProcessTime';

export default {
  name: 'StatisticsProcessTime',
  components: {
    ChartStatisticsProcessTime,
  },
  computed: {
    ...mapGetters({
      totalDutyAverageTakeOnTime: types.TOTAL_DUTY_AVERAGE_TAKE_ON_TIME,
      totalTherapistAverageTakeOnTime: types.TOTAL_THERAPIST_AVERAGE_TAKE_ON_TIME,
      totalPediatricianAverageTakeOnTime: types.TOTAL_PEDIATRICIAN_AVERAGE_TAKE_ON_TIME,
      totalSpecializedAverageTakeOnTime: types.TOTAL_SPECIALIZED_AVERAGE_TAKE_ON_TIME,
    }),
  },
};
</script>

<style lang="scss" scoped>
.statistics-time {
  margin-top: 15px;
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 30px;
  box-sizing: border-box;
  background-color: $white;
  border-radius: 10px;
  box-shadow: 0px 1px 2px $gray-shadow;
  font-size: 16px;
  line-height: 20px;
}
.statistics-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: $blue-magenta;
  margin: 0;
}
.statistics-info-title {
  font-weight: 600;
  color: $gray-dark;
}
.statistics-info {
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 10px;
  }
}
.crm-info-value {
  margin-left: 15px;
  color: $blue-magenta;
}
</style>
